import moment from "moment";
import { useRef, useState } from "react";
import { formatEventDate } from "../../../../helpers/Calendar";
import formatUserEvents from "../../../../helpers/Calendar/formatUserEvents";
import { useCalendar } from "../../../../hooks/api/calendar";
import useOutsideAlerter from "../../../../hooks/useOutsideAlerter";
import useRelativeAssociations from "../../../../hooks/useRelativeAssociations";
import useWindowDimensions from "../../../../hooks/useWindowDimensions";
import { useAppState } from "../../../../state/appState";

/**
 * @param {popupData} popupData { calendarDayEvents: [], startDate: date string if no events fall on date }
 */
const useViewMoreFromYearData = ({ popupData, closePopup }) => {
  const [selectedEvent, setSelectedEvent] = useState("");
  const { height: windowHeight } = useWindowDimensions();
  const [{ calendarTimezone }] = useAppState([]);
  const { eventFilter } = useRelativeAssociations();
  const popupRef = useRef(null);
  const { calendarList, calendarLoading } = useCalendar();
  const formattedEvents = formatUserEvents(calendarList, calendarTimezone);

  const formattedSelectedDay = moment
    .tz(popupData.startDate, calendarTimezone)
    .format();

  const { allDay, brief } = eventFilter(
    formattedEvents?.[formattedSelectedDay]
  );

  const calendarDayEvents = [...allDay, ...brief];

  const popUpContainerStyles = {
    width: popupData?.popupWidth ?? 239,
    maxHeight: windowHeight - windowHeight * 0.5,
    overflow: "scroll",
  };

  const formattedStartDate = formatEventDate(
    calendarDayEvents?.[0]?.startDate ?? popupData?.startDate,
    "MMMM Do",
    calendarTimezone
  );

  // sort events chronological order
  const eventsForDay = calendarDayEvents?.sort(
    (a, b) => moment(a?.startDate).valueOf() - moment(b?.startDate).valueOf()
  );

  useOutsideAlerter(popupRef, () => closePopup());

  return {
    selectedEvent,
    calendarLoading,
    popUpContainerStyles,
    formattedStartDate,
    eventsForDay,
    setSelectedEvent,
    calendarTimezone,
    popupRef,
  };
};

export default useViewMoreFromYearData;
